(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MMelastics"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.MMformat').forEach(function (format) {
    format.addEventListener('click', function () {
      if (format.getAttribute('type') !== 'a6') return;

      var restrictedSelection = document.querySelector('.MMelastic--a5-only.active');
      var noElastic = document.querySelector('.noElastic');

      if (restrictedSelection && noElastic) noElastic.click();
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
